import { render, staticRenderFns } from "./DataFeed.vue?vue&type=template&id=7628ae02&scoped=true"
import script from "./DataFeed.vue?vue&type=script&lang=js"
export * from "./DataFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7628ae02",
  null
  
)

export default component.exports